import IAPFB from "./IAPFB.js";
import IAPNative from "./IAPNative.js";
export default class IAP {
    constructor() {
        if (typeof (FBInstant) !== "undefined"){
            this.IAP = new IAPFB();
            this.IAP.onBuy = this.IAPOnBuy.bind(this);
            this.isAvailable = true;
        }
        else if (typeof cordova !== 'undefined'){
            this.IAP = new IAPNative();
            this.IAP.onBuy = this.IAPOnBuy.bind(this);
            this.isAvailable = true;
        }
        else{
            this.IAP = null;
            this.isAvailable = false;
        }

        
        this.catalog = [];
        this.onLoad = function () { };
        this.onBuy = function () { };
    }
    async init(productIds) {
        if (!this.IAP) return;
        await this.IAP.init(productIds);
        // const catalog = await this.IAP.getCatalog();
        // this.catalog = catalog;
        // if (this.onLoad) this.onLoad(catalog);
    }
    getCatalog() {
        if (!this.IAP) return [];
        return this.IAP.getCatalog();
    }
    IAPOnBuy(id) {
        if (this.onBuy) this.onBuy(id);
    }
    buy(id) { 
        if (!this.IAP) return;
        return this.IAP.buy(id);
    }
    restore() {
        if (!this.IAP) return;
        return this.IAP.restore();
    }
    consume(id) {
        if (!this.IAP) return;
        return this.IAP.consume(id);
    }
    getPurchases() {
        if (!this.IAP) return;
        return this.IAP.getPurchases();
    }
}